module.exports = __webpack_public_path__ + "img/quechua.4f38f7af.svg";